var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 149.24005 173.39249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "34- \u0633\u0641\u0627\u0631\u0634\u0627\u062A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80.48 86.592 80.32 86.753 19.29 86.753 19.13 86.592 80.48 86.592"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M273.77874,277.41621l-10.08,10.08h-71.35l-3.99-3.99a6.265,6.265,0,0,1,0-8.88l41.32-41.32a6.283,6.283,0,0,1,8.88,0l35.22,35.22A6.277,6.277,0,0,1,273.77874,277.41621Z",
    transform: "translate(-178.21868 -205.90373)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M320.11871,292.49623l-.16.16h-46.84a.50741.50741,0,0,1-.09-.16Z",
    transform: "translate(-178.21868 -205.90373)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.46868,287.49623H273.08874a4.9713,4.9713,0,0,1,.87994-1.18l20.82-20.81a5.26909,5.26909,0,0,1,7.47,0l18.69,18.69A5.24131,5.24131,0,0,1,322.46868,287.49623Z",
    transform: "translate(-178.21868 -205.90373)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.82873,238.94624l-25.92005,25.91a4.17051,4.17051,0,0,1-5.9,0l-25.92-25.91a4.18258,4.18258,0,0,1,0-5.91l25.92-25.91a4.17049,4.17049,0,0,1,5.9,0l25.92005,25.91A4.18259,4.18259,0,0,1,311.82873,238.94624Z",
    transform: "translate(-178.21868 -205.90373)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.86871,292.65627h-144.04a2.60979,2.60979,0,0,0-2.61005,2.6v18.17a2.60555,2.60555,0,0,0,2.61005,2.61005h.99a12.31373,12.31373,0,0,1,12.13,10.15l9.21,50.95a2.63383,2.63383,0,0,0,2.58,2.16h94.32a2.61319,2.61319,0,0,0,2.56-2.11l.36-1.8,2.25-11.35,2.89-14.59,4.63-23.47a12.37949,12.37949,0,0,1,12.12-9.93994,2.60133,2.60133,0,0,0,2.59-2.61005v-18.17A2.60557,2.60557,0,0,0,324.86871,292.65627Zm-72.66,74.37a31.007,31.007,0,0,1-6.78-61.26,31.51328,31.51328,0,0,1,6.78-.74,31,31,0,0,1,0,62Z",
    transform: "translate(-178.21868 -205.90373)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.66869,327.54622l-24.13,29.04a2.4059,2.4059,0,0,1-3.71.06l-13.94-15.2a3.11421,3.11421,0,0,1,0-4.14l2.2-2.32a2.41426,2.41426,0,0,1,3.62.1l7.66,8.55a2.4074,2.4074,0,0,0,3.76-.08l18.14-22.57a2.41006,2.41006,0,0,1,3.7-.15l2.54,2.67A3.08727,3.08727,0,0,1,272.66869,327.54622Z",
    transform: "translate(-178.21868 -205.90373)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOrder);
export default __webpack_public_path__ + "static/media/AllOrder.4bdf29ac0c2f8db90158083cc8288196.svg";
export { ForwardRef as ReactComponent };